import axios from "axios";
const API_URL = "https://diucapstone1.onrender.com/api/orders/";
// const API_URL = "http://localhost:4000/api/orders/";

// Create new goal
const createOrder = async (orderData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(API_URL, orderData, config);

  return response.data;
};

// Get user goals
const getOrders = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL, config);

  return response.data;
};

//Get Order Details

const getOrderDetails = async (orderId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.get(API_URL + `${orderId}`, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete user goal
const deleteGoal = async (goalId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.delete(API_URL + goalId, config);

  return response.data;
};

// Get admin orders
const getAdminOrders = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL + "admin", config); // Adjust the API URL based on your backend endpoint for getting admin orders

  return response.data;
};

// Delete Order

const deleteAdminOrder = async (orderId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.delete(`${API_URL}delete?id=${orderId}`, config);
  return response.data;
};

//Update Order
const updateAdminOrderStatus = async (orderId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.put(
      API_URL + "update",
      { id: orderId },
      config
    );
    return response.data;
  } catch (error) {
    throw error.response.data.message || error.message || error.toString();
  }
};

const orderService = {
  createOrder,
  getOrders,
  getOrderDetails,
  deleteGoal,
  getAdminOrders, // Add the new function here
  deleteAdminOrder,
  updateAdminOrderStatus,
};

export default orderService;
